class DayTipTileCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bookmarked = options?.bookmarked ? false
        @.boxless = options?.boxless ? false
        @.color = options?.color ? false
        @.headline = options?.headline ? 'n/a'
        @.hideBookmarkButton = options?.hideBookmarkButton ? false
        @.icon = options?.icon ? { icon: 'idea' }
        @.kicker = options?.kicker ? 'Individueller Tagestipp'
        @.tag = options?.tag ? 'div'
        @.text = options?.text ? 'n/a'

        @.CreateElement()
        return @.$el

    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'day-tip-tile'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.color
            @.$el.classList.add ('day-tip-tile--' + @.color)
        if @.boxless
            @.$el.classList.add 'day-tip-tile--boxless'
        if !@.hideBookmarkButton
            @.$el.appendChild new BookmarkCreate {
                attrs: {
                    class: ['day-tip-tile__bookmark']
                },
                marked: @.bookmarked
            }
        @.$el.innerHTML += "
            <div class='day-tip-tile__icon icon-shape-before'></div>
            <div class='kicker day-tip-tile__kicker'>#{ @.kicker }</div>
            <h3 class='headline headline--4 day-tip-tile__headline'>#{ @.headline }</h3>
            <div class='day-tip-tile__text'>#{ @.text }</div>
        "
        @.$el.querySelector '.day-tip-tile__icon'
            .appendChild window.CreateIcon @.icon
        return

window.CreateDayTipTile = (options) ->
    return new DayTipTileCreate options